import React from "react";
import { Link } from "react-router-dom";
import notFoundImage from "../images/404/404.svg";

const NotFound = () => {
  return (
    <section className="flex items-center py-20 bg-white dark:bg-black">
      <div className="container max-w-[1390px]">
        <div
          className="wow fadeInUp mx-auto max-w-[690px] text-center"
          data-wow-delay=".2s"
        >
          <img
            src={notFoundImage}
            alt="404"
            className="block w-full mx-auto mb-10"
          />
          <h2 className="mb-5 text-[50px] leading-tight font-semibold text-black dark:text-white sm:text-[80px] sm:leading-tight">
            Página No Encontrada
          </h2>
          <p className="mb-10 text-base text-body">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </p>
          <Link
            to="/"
            className="inline-block rounded-md bg-primary py-[14px] px-11 text-base font-medium text-white hover:bg-primary/90"
          >
            Volver al Inicio
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
